import useSWR from "swr"

import { apiClientCommon } from "services/apiClientCommon"

const fetchGeoJsonCoordinates = async ({ name }: { name: string }) => {
  const polygonResponse = await apiClientCommon.getMapCoordinates({
    params: { name },
  })
  if (polygonResponse.status === 200) {
    return polygonResponse.data.data
  }
  throw new Error("Failed to fetch coordinates")
}

// Custom SWR hook for fetching geo coordinates based on location name
const useGeoJsonCoordinates = (name: string) => {
  return useSWR(
    name
      ? {
          url: `/search/polygon`,
          name: name,
        }
      : null, // to resolve multiple api call issue
    fetchGeoJsonCoordinates,
    {
      loadingTimeout: 15000,
      revalidateOnFocus: false,
      dedupingInterval: 3000,
      errorRetryCount: 3,
    },
  )
}

export default useGeoJsonCoordinates
